import { Loader, LoaderOptions } from 'google-maps';
import MarkerClusterer from 'markerclustererplus-ie11';

var openedInfoWindow = null;
var infowindow = null;
var infowindows = {};
var markerCluster = null;

class OfficesMap {
	constructor() {
		$(document).ready(function () {
			if (!$('.offices-map').length) {
				return false;
			}

			const g_loader = new Loader(ajax.gmaps_key, {});

			g_loader.load().then(function (google) {
				/**
				 * initMap
				 *
				 * Renders a Google Map onto the selected jQuery element
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   jQuery $el The jQuery element.
				 * @return  object The map instance.
				 */
				function initMap($el) {
					// Find marker elements within map.
					var $markers = $el.find('.marker');

					// Create gerenic map.
					var mapArgs = {
						zoom: 1,
						//mapTypeId: google.maps.MapTypeId.ROADMAP,
						disableDefaultUI: true,
						styles: [
							{
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#f5f5f5"
									}
								]
							},
							{
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#616161"
									}
								]
							},
							{
								"elementType": "labels.text.stroke",
								"stylers": [
									{
										"color": "#f5f5f5"
									}
								]
							},
							{
								"featureType": "administrative",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "administrative.land_parcel",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "administrative.land_parcel",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#bdbdbd"
									}
								]
							},
							{
								"featureType": "administrative.neighborhood",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#eeeeee"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "labels.text",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#757575"
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#e5e5e5"
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#9e9e9e"
									}
								]
							},
							{
								"featureType": "road",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#ffffff"
									}
								]
							},
							{
								"featureType": "road",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "road.arterial",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#757575"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#dadada"
									}
								]
							},
							{
								"featureType": "road.highway",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#616161"
									}
								]
							},
							{
								"featureType": "road.local",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#9e9e9e"
									}
								]
							},
							{
								"featureType": "transit",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "transit.line",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#e5e5e5"
									}
								]
							},
							{
								"featureType": "transit.station",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#eeeeee"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#c9c9c9"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "labels.text",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"color": "#9e9e9e"
									}
								]
							}
						]
					};

					var map = new google.maps.Map($el[0], mapArgs);

					// Add markers.
					map.markers = [];
					$markers.each(function () {
						initMarker($(this), map);
					});

					var mcOptions = {
						ignoreHidden: true,
						styles: [{
							url: ajax.templateUrl + "/assets/dist/images/cluster.png",
							className: 'custom-marker-pin',
							width: 32,
							height: 32,
							textSize: 17,
							textColor: "#ffffff",
						}]
					};

					let markers = map.markers;
					markerCluster = new MarkerClusterer(map, markers, mcOptions);

					// Center
					centerMap(map);

					// Return map instance.
					return map;
				}

				function filterMarkers(markers, categories) {
					var i;

					for (i = 0; i < markers.length; i++) {
						if (categories == "*") {
							markers[i].setVisible(true);
							continue;
						}

						const match = markers[i].category.filter(element => categories.includes(element));

						if (match.length > 0) {
							markers[i].setVisible(true);
						}
						else {
							markers[i].setVisible(false);
						}
					}
				}

				/**
				 * initMarker
				 *
				 * Creates a marker for the given jQuery element and map.
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   jQuery $el The jQuery element.
				 * @param   object The map instance.
				 * @return  object The marker instance.
				 */
				function initMarker($marker, map) {
					// Get position from marker.
					var lat = $marker.data('lat');
					var lng = $marker.data('lng');

					var latLng = {
						lat: parseFloat(lat),
						lng: parseFloat(lng)
					};

					var markerImage = new google.maps.MarkerImage(ajax.templateUrl + "/assets/dist/images/pin.png",
						new google.maps.Size(33, 33),
						new google.maps.Point(0, 0),
						new google.maps.Point(18, 18));

					// Create marker instance.
					var marker = new google.maps.Marker({
						position: latLng,
						icon: markerImage,
						map: map
					});

					// Categories
					marker.category = [];

					try {
						var categories = $marker.data('product-areas');

						if (categories) {
							categories.forEach((e) => {
								marker.category.push(e);
							});
						}
					} catch (exception) {
						console.log('Error reading taxonomies.');
						console.log(exception);
					}

					// Append ID
					var m_id = $marker.data('id');

					marker.elem_id = $marker.data('id');

					// Append marker html
					infowindows[m_id] = $marker.find('.marker-content').html();

					// Append to reference for later use.
					map.markers.push(marker);

					// If marker contains HTML, add it to an infoWindow.
					if ($marker.text().length > 0) {
						// Create info window.
						infowindow = new google.maps.InfoWindow({
							content: '<div class="map-info-window">Map<div>'
						});

						// Show info window when marker is clicked.
						google.maps.event.addListener(marker, 'click', function () {
							if (openedInfoWindow != null)
								openedInfoWindow.close();

							var id = marker.elem_id;

							// Update info window.
							infowindow = new google.maps.InfoWindow({
								content: infowindows[id]
							});

							infowindow.open(map, marker);
							openedInfoWindow = infowindow;

							google.maps.event.addListener(infowindow, 'closeclick', function () {
								openedInfoWindow = null;
							});

							google.maps.event.addListener(map, 'click', function () {
								infowindow.close();
							});
						});
					}

					return marker;
				}

				/**
				 * centerMap
				 *
				 * Centers the map showing all markers in view.
				 *
				 * @date    22/10/19
				 * @since   5.8.6
				 *
				 * @param   object The map instance.
				 * @return  void
				 */
				function centerMap(map) {

					// Create map boundaries from all map markers.
					var bounds = new google.maps.LatLngBounds();
					map.markers.forEach(function (marker) {
						bounds.extend({
							lat: marker.position.lat(),
							lng: marker.position.lng()
						});
					});

					// Case: Single marker.
					if (1 == map.markers.length) {
						map.setCenter(bounds.getCenter());

						// Case: Multiple markers.
					} else {
						map.fitBounds(bounds);
					}

					// Set zoom
					var listener = google.maps.event.addListener(map, "idle", function () {
						map.setZoom(2);
						google.maps.event.removeListener(listener);
					});
				}

				// Render maps on page load.
				$(document).ready(function () {
					$('.offices-map').each(function () {
						var map = initMap($(this));

						$(this).addClass('d-block');

						var $parent = $(this).closest('.block-offices-map');
						$('.map-highlight', $parent).on('change', function () {
							var areas = $(this).val();
							filterMarkers(map.markers, areas);
							markerCluster.repaint();
							infowindow.close();
						});
					});
				});
			});
		});
	}
}

export default OfficesMap;
new OfficesMap();
